var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prompt",class:("txt-" + (_vm.options.type))},[(_vm.options.type == 'error')?_c('span',{staticClass:"xdicon xdicon-error"}):_vm._e(),_vm._v(_vm._s(_vm.options.msg))])}
var staticRenderFns = []

export { render, staticRenderFns }